// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".4abbdd138bdc80751429adeadc1c4fa1.js";
};